<script setup lang="ts">

import type {ProductRecommendation} from "@/core/interfaces/Product";
import ProductRecommendationCard from "@/product/components/ProductRecommendationCard.vue";
import {Mail, ArrowRight} from "@lucide/vue";
import ReferralRequestDialog from "@/core/components/referral/ReferralRequestDialog.vue";

defineProps<{
    recommendations: ProductRecommendation[]
}>();

const addedRecommendations = defineModel<ProductRecommendation[]>({required: true});
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="rounded-lg bg-transparent text-white">
      <h3>
        Ajoutez vos produits conseils
      </h3>
      <p class="text-sm">
        Ils seront ajoutés au bon de prise en charge
      </p>
    </div>
    <div class="flex flex-col gap-y-2 w-96">
      <ProductRecommendationCard
        v-for="recommendation in recommendations"
        :key="recommendation.id"
        :recommendation="recommendation"
        @added="addedRecommendations = [...addedRecommendations, recommendation]"
        @removed="addedRecommendations = addedRecommendations.filter(r => r.id !== recommendation.id)"
      />
      <ReferralRequestDialog type="laboratory">
        <button
          type="button"
          class="group flex items-center justify-between gap-3 my-1 px-4 py-3 rounded-lg bg-white hover:bg-gray-700 text-sm text-primary text-left"
        >
          <div class="flex items-center gap-3">
            <div class="flex size-8 shrink-0 items-center justify-center rounded-full bg-muted">
              <Mail class="size-4" />
            </div>
            <div class="flex flex-col">
              <span class="text-sm font-medium  leading-tight">Vous ne trouvez pas un produit ?</span>
              <span class="text-xs leading-tight">Cliquez ici pour référencer le laboratoire</span>
            </div>
          </div>
          <ArrowRight class="size-4 shrink-0" />
        </button>
      </ReferralRequestDialog>
    </div>
  </div>
</template>

<style scoped>

</style>
